import React from "react";
export default function BelowNavbar() {
  return (
    <>
      <div className="shadow ">
        <div className="d-lg-flex d-md-flex below-navbar-clr d-none  text-center justify-content-around bg-light py-2  mb-2 hover-blue">
          <div className="small icon-main p-2">
            Bangalore <i className="fa-solid fa-caret-down iconDown"></i>
          </div>
          <div className="small icon-main p-2">
            Chennai <i className="fa-solid fa-caret-down iconDown"></i>
          </div>
          <div className="small icon-main p-2">
            Delhi <i className="fa-solid fa-caret-down iconDown"></i>
          </div>
          <div className="small icon-main p-2">
            Gurgaon <i className="fa-solid fa-caret-down iconDown"></i>
          </div>
          <div className="small icon-main p-2">
            Hyderabad <i className="fa-solid fa-caret-down iconDown"></i>
          </div>
          <div className="small icon-main p-2">
            Kolkata <i className="fa-solid fa-caret-down iconDown"></i>
          </div>
          <div className="small icon-main p-2">
            Mumbai <i className="fa-solid fa-caret-down iconDown"></i>
          </div>
          <div className="small icon-main p-2">
            Noida <i className="fa-solid fa-caret-down iconDown"></i>
          </div>
          <div className="small icon-main p-2">
            {" "}
            Pune <i className="fa-solid fa-caret-down iconDown"></i>
          </div>
        </div>
      </div>
    </>
  );
}
